import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// have a look at the Quick start guide 
// for passing in lng and translations on init
const fallbackLng = ['en']
const availableLanguages = ['en', 'fr']

const option = {
    order: [ 'navigator', 'htmlTag', 'cookie', 'localStorage', 'path', 'subdomain' ],
    checkWhitelist: true,
}

i18n
.use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
 
  .init({
   
    fallbackLng,
    debug: false,
    whitelist: availableLanguages,
    detection: option,
    backend: {
        loadPath: '/locales/{{lng}}/translation.json',
      },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;